import { useEffect } from 'react';

/**
 * Calls `handler` when Escape is pressed, while `enabled` is true.
 *
 * Used by every dismissible overlay so the behaviour is defined once.
 */
export const useEscapeKey = (handler: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handler();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handler, enabled]);
};
